/// <amd-module name="Feed/Legacy/Components/PackageNameGridCell" />
import * as React from "react";

import * as Utils_String from "VSS/Core/Util/String";
import { Action } from "VSS/Reflux/Action";

import { Link } from "VSSUI/Link";
import { TooltipHost, TooltipOverflowMode } from "VSSUI/Tooltip";
import { VssDetailsListTitleCell } from "VSSUI/VssDetailsList";

import { Package } from "Feed/Common/Contracts/Feed";
import * as PackageResources from "Feed/Common/Resources";
import { IPackageProtocol } from "Feed/Legacy/Protocols/Common/IPackageProtocol";

export interface IPackageNameGridCellProps {
    feedName: string;
    pkg: Package;
    protocol: IPackageProtocol;
    actions: { [key: string]: Action<{}> };
    packageHref: string;
    isRecycleBin?: boolean;
}

export class PackageNameGridCell extends React.PureComponent<IPackageNameGridCellProps> {
    public render(): JSX.Element {
        const ariaLabel: string = Utils_String.format(
            PackageResources.AriaLabel_PackageList_PackageDetailsLink,
            this.props.pkg.name,
            this.props.protocol.name
        );

        return (
            <VssDetailsListTitleCell
                ariaLabel={ariaLabel}
                onRenderPrimaryText={() => {
                    return (
                        <TooltipHost content={this.props.pkg.name} overflowMode={TooltipOverflowMode.Parent}>
                            <Link
                                className={"package-name-link"}
                                href={this.props.packageHref}
                                onClick={event => {
                                    // allow browser's default behavior of Ctrl+Click to open package in new tab
                                    if (event.ctrlKey) {
                                        return;
                                    }
                                    event.preventDefault();
                                    this.props.actions.PackageSelected.invoke(this.props.pkg);
                                }}
                            >
                                {this.props.pkg.name}
                            </Link>
                        </TooltipHost>
                    );
                }}
                onRenderSecondaryText={() => {
                    // We don't want to display version when on recycle bin page
                    if (this.props.isRecycleBin) {
                        return;
                    }
                    return !this.props.pkg.versions[0].isListed || this.props.pkg.versions[0].isDeleted ? (
                        <div className={"package-version version-strikethrough"}>
                            {Utils_String.format(
                                PackageResources.PackageVersionTitle,
                                this.props.pkg.versions[0].version
                            )}
                        </div>
                    ) : (
                        <div className="package-version">
                            {Utils_String.format(
                                PackageResources.PackageVersionTitle,
                                this.props.pkg.versions[0].version
                            )}
                        </div>
                    );
                }}
                iconProps={this.props.protocol.vssIconProps}
            />
        );
    }
}
